import { Checkbox, Paper, useMediaQuery } from '@material-ui/core';
import DateInputField from 'components/PageTitleAndFilter/DateInputField/DateInputField';
import { formatISO, parseISO } from 'date-fns';

const DateFilter = ({ filters = {}, setFilters = () => {} }) => {
  const isMobileScreen = useMediaQuery('(max-width: 866px)');

  const handleFilterChange = (inputName, value) => {
    setFilters((prev) => ({
      ...prev,
      [inputName]: value
    }));
  };

  return (
    <Paper
      className="pRelative dFlex bgWhite filterContainer"
      elevation={3}
      style={{
        padding: '15px 10px',
        paddingBlock: '10px',
        flexWrap: 'wrap',
        alignItems: isMobileScreen ? 'center' : 'flex-end',
        gap: isMobileScreen ? 0 : '5px',
      }}
    >
      <DateInputField
        margin="0 10px 0 0"
        label="DATA INÍCIO"
        initialDate={parseISO(filters.startAt)}
        filterName="startAt"
        size={0}
        inputSizes={isMobileScreen ? ['95px'] : ['100px']}
        handleFilter={handleFilterChange}
        resetDate={filters}
      />
      <DateInputField
        margin="0 0 0 0"
        label="DATA FIM"
        size={0}
        inputSizes={isMobileScreen ? ['95px'] : ['100px']}
        initialDate={parseISO(filters.endAt)}
        filterName="endAt"
        handleFilter={handleFilterChange}
        resetDate={filters}
      />

      <div className={`isLabelClearedFilterBox pAbsolute dFlex alignCenter ${filters?.isLabelCleared && 'active'}`} style={{ right: 10, top: 5 }}>
        <label
          onClick={() => {
            handleFilterChange('isLabelCleared', !filters?.isLabelCleared);
          }}
          className="initialTransform fontWeightNormal fontSizeDefault dFlex alignEnd cursorPointer mb3"
          style={{
            lineHeight: 'normal'
          }}
        >
          Sem Baixa
        </label>
      </div>

      <div className="lastSevenDaysViewBox ml-auto mtAuto">
        <span
          style={{ color: '#5061F0', fontWeight: 600 }}
          onClick={() => {
            const now = new Date();
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(now.getDate() - 6);
            setFilters((prev) => ({
              ...prev,
              startAt: formatISO(sevenDaysAgo, { representation: 'date' }),
              endAt: formatISO(now, { representation: 'date' })
            }));
          }}
          className="cursorPointer filterDays"
        >
          {isMobileScreen ? '7 dias' : 'Visualizar últimos 7 dias'}
        </span>
      </div>
    </Paper>
  );
};

export default DateFilter;
